import { db } from '../../firebase';
import { doc, getDoc, Timestamp, runTransaction } from 'firebase/firestore';

export const generateUniqueGameCode = async () => {

  // Reserve atomically so simultaneous hosts cannot claim the same room.
  for (let attempt = 0; attempt < 40; attempt++) {
    const code = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
    const reserved = await runTransaction(db, async transaction => {
      const ref = doc(db, 'gameSessions', code);
      const snapshot = await transaction.get(ref);
      if (snapshot.exists()) return false;
      transaction.set(ref, { code, createdAt: Timestamp.now() });
      return true;
    });
    if (reserved) return code;
  }
  throw new Error('We couldn’t find an available room code. Please try again.');
}

export const checkIfGameCodeExists = async (gameCode) => {
  if (!/^\d{4}$/.test(gameCode)) return { exists: false };
  const gameSessionRef = doc(db, 'gameSessions', gameCode);
  const docSnap = await getDoc(gameSessionRef);

  if (!docSnap.exists()) {
    return { exists: false };
  }

  const data = docSnap.data();
  const createdAt = data.createdAt?.toDate?.();
  if (!createdAt) return { exists: true, expiredCode: true };
  const now = new Date();
  
  const expired = (now - createdAt) / (1000 * 60 * 60) > 24;

  return {
    exists: true,
    expiredCode: expired
  };
}
